import { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

type Props = {
    size?: string | number
    className?: string
    innerClassName?: string
}

class Loader extends Component<Props> {
    static defaultProps = {
        size: '5',
    }

    render() {
        const { size, className, innerClassName } = this.props
        return (
            <div className={className}>
                <svg className={classnames(`animate-spin h-${size} w-${size} dark:text-white`, innerClassName)} fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                </svg>
            </div>
        )
    }
}

export default Loader
